export default "__VITE_ASSET__d3818e8b__"